(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["evaro-footer"]) return;
  try {
    
  if (!customElements.get('evaro-motion')) {
    customElements.define('evaro-motion', class extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('button');
        this.media = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.apply = (paused) => {
          document.body.classList.toggle('motion-paused', paused);
          this.button.setAttribute('aria-pressed', String(paused));
          this.button.querySelector('[data-motion-label]').textContent = paused ? this.button.dataset.resumeLabel : this.button.dataset.pauseLabel;
        };
        this.clickHandler = () => {
          const paused = !document.body.classList.contains('motion-paused');
          this.apply(paused);
          try { sessionStorage.setItem('evaro-motion-paused', String(paused)); } catch {}
        };
        this.mediaHandler = () => {
          this.hidden = this.media.matches;
          this.apply(this.media.matches || this.savedPause());
        };
        this.button.addEventListener('click', this.clickHandler);
        this.media.addEventListener('change', this.mediaHandler);
        this.mediaHandler();
      }
      savedPause() { try { return sessionStorage.getItem('evaro-motion-paused') === 'true'; } catch { return false; } }
      disconnectedCallback() {
        this.button?.removeEventListener('click', this.clickHandler);
        this.media?.removeEventListener('change', this.mediaHandler);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["evaro-hero"] && !Shopify.designMode) return;
  try {
    
  function focusSignupResult(root = document) {
    const result = root.querySelector('[data-signup-result]');
    if (result) result.focus({ preventScroll: false });
  }
  focusSignupResult();
  document.addEventListener('shopify:section:load', (event) => focusSignupResult(event.target));
  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[href="#EvaroPrivacy"]');
    if (!link) return;
    const details = document.getElementById('EvaroPrivacy');
    if (details) details.open = true;
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["evaro-range"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('evaro-rides')) {
    customElements.define('evaro-rides', class extends HTMLElement {
      connectedCallback() {
        this.events = new AbortController();
        const options = { signal: this.events.signal };
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.hover = window.matchMedia('(hover: hover)');
        this.cards = Array.from(this.querySelectorAll('.range-card'), (card) => ({
          card, button: card.querySelector('.category-art'), vehicle: card.querySelector('.category-vehicle')
        }));
        this.syncMotion = () => {
          this.paused = this.dataset.motionEnabled === 'false' || this.reducedMotion.matches || document.body.classList.contains('motion-paused');
          this.cards.forEach(({ card, button }) => {
            button.disabled = this.paused;
            if (this.paused) card.classList.remove('is-driving');
          });
        };
        this.cards.forEach(({ card, button, vehicle }) => {
          const drive = () => {
            if (!this.paused && !card.classList.contains('is-driving')) card.classList.add('is-driving');
          };
          card.addEventListener('pointerenter', (event) => {
            if (event.pointerType !== 'touch' && this.hover.matches) drive();
          }, options);
          button.addEventListener('click', drive, options);
          const finish = (event) => {
            if (event.target === vehicle && event.animationName === 'category-drive-through') card.classList.remove('is-driving');
          };
          vehicle.addEventListener('animationend', finish, options);
          vehicle.addEventListener('animationcancel', finish, options);
        });
        this.reducedMotion.addEventListener('change', this.syncMotion, options);
        this.motionObserver = new MutationObserver(this.syncMotion);
        this.motionObserver.observe(document.body, { attributes: true, attributeFilter: ['class'] });
        this.syncMotion();
      }
      disconnectedCallback() {
        this.events?.abort();
        this.motionObserver?.disconnect();
        this.cards?.forEach(({ card }) => card.classList.remove('is-driving'));
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
